import React, { useEffect, useRef, useState } from "react";
import "./Setting.scss";
import { useForm } from "react-hook-form";
import { useStateValue } from "../../StateProvider";
import { checkSysConfig, listSysconfigs, updateSysConfig } from "../../apiCall";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { validateNoBlankSpaces } from "../../utils/formValidation";

const Setting = () => {
  const [tab, setTab] = useState("information");
  const [, dispatch] = useStateValue();
  const [isCancel, setIsCancel] = useState(false);
  const [editStatus, setEditStatus] = useState(false);

  // **************************************************** company info start *****************************************************
  const queryKey = ["sysconfig"];
  const fetchSysConfigInfo = async () => {
    // Perform the API call to fetch company info
    try {
      const re = await listSysconfigs();
      if (re?.status === 200) {
        const data = {
          fileType:
            re?.data.data["Allowed File types for attachment"][
            "KeyDescription"
            ],
          daysUpcoming:
            re?.data.data["Days for Upcoming Task"]["KeyDescription"],
          attachmentSize:
            re?.data.data["Maximum Attachment Size in MB"]["KeyDescription"],
          rowMultiLine:
            re?.data.data["Rows in MultiLine List"]["KeyDescription"],
          rowSingleLine:
            re?.data.data["Rows in Single Line List"]["KeyDescription"],
          reportDateRange:
            re?.data.data["Report Days Upto"]["KeyDescription"],
          upcomingTaskRepetition:
            re?.data.data["Upcoming Task Repetition"]["KeyDescription"],
          overdueTaskRepetition:
            re?.data.data["Overdue Task Repetition"]["KeyDescription"],
          delayedTaskRepetition:
            re?.data.data["Delayed Task Repetition"]["KeyDescription"],
          Minute:
            re?.data.data["Minute"]["KeyDescription"],
          Hour:
            re?.data.data["Hour"]["KeyDescription"],
          Month:
            re?.data.data["Month"]["KeyDescription"],
          dayOfMonth:
            re?.data.data["Day of Month"]["KeyDescription"],
          dayOfWeek:
            re?.data.data["Day of Week"]["KeyDescription"],
        };
        setSysConfigInfo(data);
        setValue(
          "Allowed File types for attachment",
          re?.data.data["Allowed File types for attachment"]["Value"]
        );
        setValue(
          "Days for Upcoming Task",
          re?.data.data["Days for Upcoming Task"]["Value"]
        );
        setValue(
          "Maximum Attachment Size in MB",
          re?.data.data["Maximum Attachment Size in MB"]["Value"]
        );
        setValue(
          "Rows in MultiLine List",
          re?.data.data["Rows in MultiLine List"]["Value"]
        );
        setValue(
          "Rows in Single Line List",
          re?.data.data["Rows in Single Line List"]["Value"]
        );
        setValue(
          "Report Days Upto",
          re?.data.data["Report Days Upto"]["Value"]
        );
        setValue(
          "Upcoming Task Repetition",
          re?.data.data["Upcoming Task Repetition"]["Value"]
        );
        setValue(
          "Overdue Task Repetition",
          re?.data.data["Overdue Task Repetition"]["Value"]
        );
        setValue(
          "Delayed Task Repetition",
          re?.data.data["Delayed Task Repetition"]["Value"]
        );
        setValue(
          "Day of Month",
          re?.data.data["Day of Month"]["Value"]
        );
        setValue(
          "Day of Week",
          re?.data.data["Day of Week"]["Value"]
        );
        setValue(
          "Hour",
          re?.data.data["Hour"]["Value"]
        );
        setValue(
          "Minute",
          re?.data.data["Minute"]["Value"]
        );
        setValue(
          "Month",
          re?.data.data["Month"]["Value"]
        );

      } else if (re?.response) {
        toast.error(re?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };

  const { data, refetch } = useQuery({
    queryKey,
    queryFn: fetchSysConfigInfo,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [sysConfigInfo, setSysConfigInfo] = useState({});

  // **************************************************** company info start *****************************************************
  //******************************************attachment start **************************************************
  const [title, setTitle] = useState("System Configuration");
  const formRef = useRef(null);

  //******************************************attachment end **************************************************
  // **************************************************** form start *****************************************************
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues: {} });
  const watchField = watch();

  const onSubmit = async (data) => {
    dispatch({ type: "SET_LOADING", status: true });
    const re = await updateSysConfig(data);
    if (re?.status === 200) {
      setEditStatus(false);
      dispatch({ type: "SET_SYS_CONFIG", data: data });

      toast.success(re?.data?.message);
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
    dispatch({ type: "SET_LOADING", status: false });
  };

  // **************************************************** form start end *****************************************************

  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area mb-10">
        <div className="container-fluid ">
          <div className="mx-n6 mt-n6 pt-6 mb-6 header">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
          align-items-center justify-content-between px-6"
                >
                  <div className="mb-6 mb-lg-0">
                    <div className="d-flex align-items-center">
                      <div className="">
                        <h1 className="mb-0 h3 ">{title} </h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab px-6">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        className={`${tab === "information"
                          ? "nav-link active "
                          : "nav-link"
                          }`}
                      // onClick={() => {
                      //   setTab("information");
                      //   setTitle("Update Company");
                      // }}
                      >
                        Information
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card mb-5">
                            {/* card body */}
                            <div className="card-body">
                              {/* form */}
                              <div className="row col-md-6 col-12 ">
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Days for Upcoming Task{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter Days for Upcoming Task"
                                    disabled={!editStatus}
                                    min={1}
                                    {...register("Days for Upcoming Task", {
                                      required:
                                        "Days for Upcoming Task is required",
                                        validate: validateNoBlankSpaces,
                                        
                                    })}
                                  />


                                  <small className="ms-2">{sysConfigInfo?.daysUpcoming}</small>
                                  {errors["Days for Upcoming Task"] && (
                                    <div className="error">
                                      {errors["Days for Upcoming Task"].message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Maximum Attachment Size in MB{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter Maximum Attachment Size in MB"
                                    disabled={!editStatus}
                                    min={1}
                                    max={100}
                                    {...register(
                                      "Maximum Attachment Size in MB",
                                      {
                                        required:
                                          "Maximum Attachment Size in MB is required",
                                          validate: validateNoBlankSpaces,
                                      }
                                    )}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.attachmentSize}</small>

                                  {errors["Maximum Attachment Size in MB"] && (
                                    <div className="error">
                                      {
                                        errors["Maximum Attachment Size in MB"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Rows in MultiLine List{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="number"
                                    min="1"
                                    max="50"

                                    className="form-control"
                                    placeholder="Enter Rows in MultiLine List."
                                    {...register(
                                      "Rows in MultiLine List",

                                      {
                                        required:
                                          "Rows in MultiLine List is required",
                                          validate: validateNoBlankSpaces,
                                      }
                                    )}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.rowMultiLine}</small>

                                  {errors["Rows in MultiLine List"] && (
                                    <div className="error">
                                      {errors["Rows in MultiLine List"].message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Rows in Single Line List{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="number"
                                    min="1"
                                    max="50"
                                    className="form-control"
                                    placeholder="Enter  Rows in Single Line List."
                                    {...register("Rows in Single Line List", {
                                      required:
                                        "Rows in Single Line List is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.rowSingleLine}</small>

                                  {errors["Rows in Single Line List"] && (
                                    <div className="error">
                                      {
                                        errors["Rows in Single Line List"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Report Days Upto{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="number"
                                    min="1"
                                    max="1000"
                                    className="form-control"
                                    placeholder="Enter  Report Days Upto."
                                    {...register("Report Days Upto", {
                                      required:
                                        "Report Days Upto is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.reportDateRange}</small>

                                  {errors["Report Days Upto"] && (
                                    <div className="error">
                                      {
                                        errors["Report Days Upto"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Upcoming Task Repetition{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"

                                    className="form-control"
                                    placeholder="Enter Upcoming Task Repetition."
                                    {...register("Upcoming Task Repetition", {
                                      required:
                                        "Upcoming Task Repetition is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.upcomingTaskRepetition}</small>

                                  {errors["Upcoming Task Repetition"] && (
                                    <div className="error">
                                      {
                                        errors["Upcoming Task Repetition"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Overdue Task Repetition{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"

                                    className="form-control"
                                    placeholder="Enter Overdue Task Repetition."
                                    {...register("Overdue Task Repetition", {
                                      required:
                                        "Overdue Task Repetition is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.overdueTaskRepetition}</small>

                                  {errors["Overdue Task Repetition"] && (
                                    <div className="error">
                                      {
                                        errors["Overdue Task Repetition"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Delayed Task Repetition{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"

                                    className="form-control"
                                    placeholder="Enter Delayed Task Repetition."
                                    {...register("Delayed Task Repetition", {
                                      required:
                                        "Delayed Task Repetition is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.delayedTaskRepetition}</small>

                                  {errors["Delayed Task Repetition"] && (
                                    <div className="error">
                                      {
                                        errors["Delayed Task Repetition"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Minute{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"

                                    className="form-control"
                                    placeholder="Enter Minute."
                                    {...register("Minute", {
                                      required:
                                        "Minute is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.Minute}</small>

                                  {errors["Minute"] && (
                                    <div className="error">
                                      {
                                        errors["Minute"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Hour{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"

                                    className="form-control"
                                    placeholder="Enter Hour."
                                    {...register("Hour", {
                                      required:
                                        "Hour is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.Hour}</small>

                                  {errors["Hour"] && (
                                    <div className="error">
                                      {
                                        errors["Hour"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Month{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"

                                    className="form-control"
                                    placeholder="Enter Month."
                                    {...register("Month", {
                                      required:
                                        "Month is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.Month}</small>

                                  {errors["Month"] && (
                                    <div className="error">
                                      {
                                        errors["Month"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Day Of Month{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"

                                    className="form-control"
                                    placeholder="Enter Day Of Month."
                                    {...register("Day of Month", {
                                      required:
                                        "Day Of Month is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.dayOfMonth}</small>

                                  {errors["Day of Month"] && (
                                    <div className="error">
                                      {
                                        errors["Day of Month"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Day Of Week{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    disabled={!editStatus}
                                    type="text"

                                    className="form-control"
                                    placeholder="Enter Day Of Week."
                                    {...register("Day of Week", {
                                      required:
                                        "Day Of Week is required",
                                        validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.dayOfWeek}</small>

                                  {errors["Day of Week"] && (
                                    <div className="error">
                                      {
                                        errors["Day of Week"]
                                          .message
                                      }
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Allowed File types for attachment{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    disabled={!editStatus}
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Allowed File types for attachment."
                                    rows={3}
                                    {...register(
                                      "Allowed File types for attachment",

                                      {
                                        required:
                                          "Allowed File types for attachment is required",
                                          validate: validateNoBlankSpaces,
                                      }
                                    )}
                                  />
                                  <small className="ms-2">{sysConfigInfo?.fileType}</small>

                                  {errors[
                                    "Allowed File types for attachment"
                                  ] && (
                                      <div className="error">
                                        {
                                          errors[
                                            "Allowed File types for attachment"
                                          ].message
                                        }
                                      </div>
                                    )}
                                </div>

                              </div>
                            </div>
                          </div>
                          <div className="mt-4 d-flex justify-content-between">
                            <div className="left d-flex">
                              {editStatus && (
                                <div
                                  className="  btn btn-outline-danger me-2 mb-4"
                                  onClick={() => {
                                    setEditStatus(false);
                                    setIsCancel(true);
                                    refetch()
                                  }}
                                >
                                  Cancel
                                </div>
                              )}
                              {/* <div className="  rounded-circl notification-count">
                                <a
                                  href="#!"
                                  className="btn btn-dark me-2"
                                  onClick={() => handleExternalSubmit()}
                                >
                                  Attachments
                                </a>
                                <div className="notification-count d-flex justify-content-center">
                                  {attachmentCount}
                                </div>
                              </div> */}
                            </div>
                            <div className="right mb-4">
                              {!editStatus ? (
                                <div
                                  className="btn btn-primary"
                                  onClick={() => {
                                    setEditStatus(true);
                                    setIsCancel(false);
                                  }}
                                >
                                  Edit
                                </div>
                              ) : (
                                <button className="btn btn-primary">
                                  Save
                                </button>
                              )}
                            </div>
                          </div>
                        </form>
                      );

                    default:
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
